<template>
  <div class="groupage-cargo-info">
    <h2 class="vz-text-align-left">Что означает "сборный груз"</h2>
    <p>
      Заказы нескольких клиентов из одного города отправления объединяются в одном 
      транспортном средстве для отправки сборным грузом в города получения.
    </p>
    <template v-for="item, index in items" :key="index">
      <h3 class="vz-text-align-left mt-40">{{ item.title }}</h3>
      <ul class="public-list public-list-square">
        <li  v-for="el, i in item.info" :key="i">
          <span>
            {{ el.text }}
            <nuxt-link 
              v-if="el.link?.to" 
              :to="el.link.to" 
              target="_blank"
            >
              {{ el.link.title }}
            </nuxt-link>
            {{ el?.additional }}
          </span>
        </li>
      </ul>
    </template>
  </div>
</template>

<script setup lang="ts">
const items = [
  {
    title: 'Преимущества сборных перевозок',
    info: [
      {
        text: 'Каждый клиент оплачивает только место, занимаемое его грузом в общем транспортном средстве, а не машину полностью'
      },
      {
        text: 'В составе сборной грузоперевозки могут присутствовать отправления средних и малых габаритов, а также негабаритные грузы'
      },
      {
        text: 'Можно доставить груз в любом количестве. Нет требований к минимальному объему'
      },
      {
        text: 'Рейсы между городами осуществляются по фиксированному расписанию.',
        link: {
            title: 'Подробнее в форме «расписания рейсов».',
            to: { name: 'run-schedule' }
        },
        additional: 'Это позволяет клиентам точно планировать свои действия'
      }
    ]
  },
  {
    title: 'Расчет цены грузоперевозки',
    info: [
      {
        text: 'Стоимость перевозки сборного груза зависит от параметров заказа (объёма и веса), расстояния между пунктами отправления и получения, а также от наличия дополнительных услуг - погрузки-разгрузки, хранения на складе и т.д.'
      },
    ]
  }
]
</script>

<style lang="scss" scoped>
</style>
